"use strict";
// (C) 2019-2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMobileView = void 0;
var SCREEN_BREAKPOINT_SM = 640;
// https://github.com/gooddata/gdc-goodstrap/blob/master/src/core/MediaQueries.js#L61
exports.isMobileView = function () { return window.innerWidth <= SCREEN_BREAKPOINT_SM; };
//# sourceMappingURL=responsive.js.map